export const REGIONS = {
  US: 'US',
  EU: 'EU',
};

export const VALID_LOCALE_REGIONS = {
  [REGIONS.EU]: 'en-GB',
  [REGIONS.US]: 'en-US',
};
